import {useContext} from "../_snowpack/pkg/react.js";
export default function useRequiredContext(context) {
  const resolved = useContext(context);
  if (resolved !== void 0 && resolved !== null) {
    return resolved;
  }
  throw new Error(`No provider found for ${context.displayName ? `the '${context.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`);
}
